import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { searchContent } from '@plone/volto/actions';
import PropTypes from 'prop-types';
import { Helmet } from '@plone/volto/helpers';
import { Icon } from 'semantic-ui-react';
import 'remixicon/fonts/remixicon.css';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';

const getCompanyContent = (array = []) =>
  array.map((obj, item) => {
    obj[0] = item;
    return obj;
  }, {});

const CompanyView = ({ data }) => {
  const dispatch = useDispatch();
  const companies = useSelector((state) =>
    getCompanyContent(state.search.subrequests.company?.items),
  );

  const content = useSelector((state) => state.workflow.transition);

  const isotope = useRef(null);

  const [searchQuery, setSearchQuery] = useState('');
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    dispatch(
      searchContent(
        '/',
        {
          portal_type: ['company'],
          b_size: 1000,
          fullobjects: true,
        },
        'company',
      ),
      setIsReady(true)
    );
  }, [dispatch, content]);

  useEffect(() => {
    if (!companies.length || isotope.current) return;

    const init = () => {
      if (!window.Isotope || isotope.current) return false;
      isotope.current = new window.Isotope('.gridCompanies', {
        itemSelector: '.grid-company-item',
        layoutMode: 'fitRows',

        getSortData: {
          ort: (itemElem) =>
            itemElem.querySelector('.gridCompanyOrt')?.textContent.trim() || '',
        },

        sortBy: 'ort',
        sortAscending: true,
      });
    };

    if (init()) return;

    const interval = setInterval(() => {
      if (init()) clearInterval(interval);
    }, 50);

    return () => clearInterval(interval);
  }, [companies]);

  useEffect(() => {
    if (isReady && isotope.current) {
      let qsRegex = searchQuery ? new RegExp(searchQuery, 'gi') : null;

      isotope.current.arrange({
        filter: (itemElem) => {
          return qsRegex ? itemElem.textContent.match(qsRegex) : true;
        },
      });
    }
  }, [searchQuery, isReady]);

  return (
    <>
      <Helmet>
        <script
          defer
          src="https://unpkg.com/isotope-layout@3/dist/isotope.pkgd.min.js"
        ></script>
      </Helmet>

      <div className='searchWrapper'>
        <Icon name="search" size="large" className="searchIcon" />
        <input
          type="text"
          className="quicksearch"
          placeholder="Suche..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <Grid
        className="gridCompanies"
        container
        spacing={{ md: 8, sm: 8 }}
        rowSpacing={{ xs: 8 }}
      >
        {companies.map((company) => (
          <Grid
            item
            className="grid-company-item"
            key={company.UID}
          >
            <div className="gridCompanyContent">
              <div className="gridCompanyContentNameDiv">
                <p className="gridCompanyContentName">{company.name}</p>
              </div>
              <div className="stackWrapper">
                <Stack spacing={0.5}>
                  {company.person && <p>{company.person}</p>}
                  <p>{company.strasse}</p>
                  <p className="gridCompanyOrt">{company.ort}</p>
                  <p className='stackNumber'>{company.nummer}</p>
                  {company.webseite && (
                    <a
                      href={company.webseite.startsWith('http') ? company.webseite : `https://${company.webseite}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className='stackLink'
                    >
                      {company.webseite}
                    </a>
                  )}
                </Stack>

                <div className='logoWrapper'>
                  <img
                    className="gridCompanyImg"
                    src={company.image?.scales?.teaser?.download}
                    alt={company.image?.filename}
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

CompanyView.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
};

export default CompanyView;
